import { render, staticRenderFns } from "./NirAccomplishmentCard.vue?vue&type=template&id=2930cb4c&scoped=true"
import script from "./NirAccomplishmentCard.vue?vue&type=script&lang=js"
export * from "./NirAccomplishmentCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2930cb4c",
  null
  
)

export default component.exports